import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@gc/db-types';
import { config } from '../config';

let supabaseInstance: SupabaseClient<Database> | null = null;

// Get or create the Supabase client
export const getSupabaseClient = (): SupabaseClient<Database> => {
  if (!supabaseInstance) {
    
    
    supabaseInstance = createClient<Database>(config.SUPABASE_URL, config.SUPABASE_ANON_KEY, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    });
  }
  
  return supabaseInstance;
};

// For convenience, also export as supabase (but it's a getter)
export const supabase = getSupabaseClient;